import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiSliders, FiUsers, FiShield, FiBell } from 'react-icons/fi';

const Settings = () => {
  return (
    <div className="max-w-4xl space-y-8">
      <div>
        <h1 className="text-3xl font-bold text-slate-100">Organization Settings</h1>
        <p className="text-slate-400 mt-1">Configure your ComplianceCloud workspace.</p>
      </div>

      <div className="bg-slate-800/40 border border-slate-700/50 rounded-xl overflow-hidden backdrop-blur-sm flex flex-col md:flex-row">
        <div className="w-full md:w-64 bg-slate-900/50 p-6 border-r border-slate-700/50">
          <nav className="space-y-2">
            {[
              { id: 'general', name: 'General', icon: FiSliders, active: true },
              { id: 'team', name: 'Team Access', icon: FiUsers, active: false },
              { id: 'security', name: 'Security', icon: FiShield, active: false },
              { id: 'notifications', name: 'Notifications', icon: FiBell, active: false },
            ].map(tab => (
              <button 
                key={tab.id}
                className={`w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  tab.active 
                    ? 'bg-amber-500/10 text-amber-400 border border-amber-500/30' 
                    : 'text-slate-400 hover:bg-slate-800 hover:text-slate-200'
                }`}
              >
                <SafeIcon icon={tab.icon} /> {tab.name}
              </button>
            ))}
          </nav>
        </div>
        
        <div className="flex-1 p-8 space-y-6">
          <h2 className="text-xl font-semibold text-slate-200 border-b border-slate-700/50 pb-4">General Configuration</h2>
          
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-400 mb-1">Company Name</label>
              <input type="text" defaultValue="Acme Corp" className="w-full bg-slate-900 border border-slate-700 rounded-lg px-4 py-2 text-slate-200 focus:outline-none focus:border-amber-500/50 focus:ring-1 focus:ring-amber-500/50" />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-slate-400 mb-1">Primary Framework</label>
              <select className="w-full bg-slate-900 border border-slate-700 rounded-lg px-4 py-2 text-slate-200 focus:outline-none focus:border-amber-500/50">
                <option>SOC 2 Type II</option>
                <option>ISO 27001</option>
                <option>GDPR</option>
              </select>
            </div>

            <div className="pt-4 flex items-center justify-between border-t border-slate-700/50">
              <div>
                <h4 className="text-slate-200 font-medium">Read-Only Mode</h4>
                <p className="text-xs text-slate-500">Prevent changes to evidence and checklists.</p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" className="sr-only peer" />
                <div className="w-11 h-6 bg-slate-700 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-amber-500"></div>
              </label>
            </div>
          </div>

          <div className="pt-6">
            <button className="bg-amber-500 hover:bg-amber-400 text-slate-900 px-6 py-2 rounded-lg font-medium transition-colors">
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;